export const SEXES = {
  SKINS: "SKINS",
};
